var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fw-itinfo"},[_c('van-nav-bar',{staticStyle:{"background-color":"#CCD5E6"},attrs:{"title":_vm.title,"left-text":"","left-arrow":"","fixed":true},on:{"click-left":_vm.onClickLeft}}),(_vm.imgText.itType==2)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.imgText.description)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }